import { XIF } from '../utils/excel-functions-utils';
import tclocal from './ter-consts-local-lib';
import { SPACE } from '../utils/frfr-string-consts';
import { terUtilsUnitsMilimetriToMetri } from './ter-utils';
import { _getParamsFromLib } from './ter-params-utils';
import { _virbom_manipulator } from '../utils/frfr-virbom-manipulator-utils';
import { virbomCounter } from '../utils/frfr-virbom-counter-utils';
import { SINGLE_PIECE_PER_NEXT_OPERATION_UNIT } from './virtel-consts';


/*
export const derivatPoluproizvod_modulprofil_dopuni = (p) => {
  // SPECIJALNI KORAK
  // _____ dodajemo neke podatke koji su mu potrebni!
  let dopunjen = {
    ...p,
    ..._getParamsFromLib("terkk$profilosnovni")
  };
  return dopunjen;
}
*/


const ident_za_profile_RECNIK = {
  // DL 2023-04-28: Ove idente vise ne koristimo. mozem oda stavimo null i nakon exporta u trecem softveru ce im biti dodeljeni identi.
  "STD-50": "PRF000001",
  "STD-70": "PRF000002",
  "TB-50": "PRF000003",
  "TB-70": "PRF000004",
  "STD-BELA-50": "PRF000005",
  "STD-BELA-70": "PRF000006",
  "TB-BELA-50": "PRF000007",
  "TB-BELA-70": "PROF008",
  "TB-PLAVA-70": "PROF009",
  "TB-ZELENA-70": "PROF010",
};


// TODO ovo ispod treba prebaciti u neku bilioteku materija...

const ident_materijala_za_profil_osnovni_RECNIK = {
  "STD-50": "PTP08AA00000",
  "STD-70": "PTP09AA00000",
  "TB-50": "PTB51AA00000",
  "TB-70": "PTB71AA00000",
  "STD-BELA-50": "PTP08ADAN000",
  "STD-BELA-70": "PTP09ADAN000",
  "TB-BELA-50": "PTB51ADBC000",
  "TB-BELA-70": "PTB71ADAN000",
  "TB-PLAVA-70": "PTB71ADAM000",
  "TB-ZELENA-70": "PTB71ADAP000",
};

const ident_materijala_za_profil_pregradni_RECNIK = {
  "STD-50": "PTP11AA00000",
  "STD-70": "PTP10AA00000",
  "TB-50": "PTB52AA00000",
  "TB-70": "PTB72AA00000",
  "STD-BELA-50": "PTP11ADAN000",
  "STD-BELA-70": "PTP10ADAN000",
  "TB-BELA-50": "PTB52ADBC000",
  "TB-BELA-70": "PTB72ADAN000",
  "TB-PLAVA-70": "PTB72ADAM000",
  "TB-ZELENA-70": "PTB72ADAP000",
};

const naziv_materijala_za_profil_osnovni_RECNIK = {
  "STD-50": "PROFIL AL OSNOVNI P8 50 TP08 SIROV",
  "STD-70": "PROFIL AL OSNOVNI P9 70 TP09 SIROV",
  "TB-50": "PROFIL AL OSNOVNI TERMALNI PREKID PTT 150-45 TB51 SIROV",
  "TB-70": "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 SIROV",
  "STD-BELA-50": "PROFIL AL OSNOVNI P8 50 TP08 PLASTIFICIRAN RAL9016MAT",
  "STD-BELA-70": "PROFIL AL OSNOVNI P9 70 TP09 PLASTIFICIRAN RAL9016MAT",
  "TB-BELA-50": "PROFIL AL OSNOVNI TERMALNI PREKID PTT 150-45 TB51 PLASTIFICIRAN RAL9003",
  "TB-BELA-70": "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 PLASTIFICIRAN RAL9016MAT",
  "TB-PLAVA-70": "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 PLASTIFICIRAN RAL5007MAT",
  "TB-ZELENA-70": "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 PLASTIFICIRAN RAL6024MAT"
};

const naziv_materijala_za_profil_pregradni_RECNIK = {
  "STD-50": "PROFIL AL PREGRADNI P11 50 TP11 SIROV",
  "STD-70": "PROFIL AL PREGRADNI P10 70 TP10 SIROV",
  "TB-50": "PROFIL AL PREGRADNI TERMALNI PREKID PTT 250-45 TB52 SIROV",
  "TB-70": "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 SIROV",
  "STD-BELA-50": "PROFIL AL PREGRADNI P11 50 TP11 PLASTIFICIRAN RAL9016MAT",
  "STD-BELA-70": "PROFIL AL PREGRADNI P10 70 TP10 PLASTIFICIRAN RAL9016MAT",
  "TB-BELA-50": "PROFIL AL PREGRADNI TERMALNI PREKID PTT 250-45 TB52 PLASTIFICIRAN RAL9003",
  "TB-BELA-70": "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 PLASTIFICIRAN RAL9016",
  "TB-PLAVA-70": "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 PLASTIFICIRAN RAL5007MAT",
  "TB-ZELENA-70": "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 PLASTIFICIRAN RAL6024MAT",
};

const _temp_prevodilac = (key, recnik) => {
  if (key in recnik) {
    return recnik[key];
  } else {
    return null;
  }
};


const _calculate_ident = (C6) => {
  // Nova verzija identa
  /*
  const calculated_ident = XIF(C6 === "STD-50", "PRF000001", XIF(C6 === "STD-70", "PRF000002", XIF(C6 === "TB-50", "PRF000003", XIF(C6 === "TB-70", "PRF000004", XIF(C6 === "STD-BELA-50", "PRF000005", XIF(C6 === "STD-BELA-70", "PRF000006", XIF(C6 === "TB-BELA-50", "PRF000007", XIF(C6 === "TB-BELA-70", "PROF008", XIF(C6 === "TB-PLAVA-70", "PROF009", XIF(C6 === "TB-ZELENA-70", "PROF010", null))))))))));
  return calculated_ident;
  */
  return _temp_prevodilac(C6, ident_za_profile_RECNIK);
};

const _calculate_ident_materijala_za_profil_osnovni = (C6) => {
  /*
  const tip = XIF(C6 === "STD-50", "PTP08AA00000", XIF(C6 === "STD-70", "PTP09AA00000", XIF(C6 === "TB-50", "PTB51AA00000", XIF(C6 === "TB-70", "PTB71AA00000", XIF(C6 === "STD-BELA-50", "PTP08ADAN000", XIF(C6 === "STD-BELA-70", "PTP09ADAN000", XIF(C6 === "TB-BELA-50", "PTB51ADBC000", XIF(C6 === "TB-BELA-70", "PTB71ADAN000", XIF(C6 === "TB-PLAVA-70", "PTB71ADAM000", XIF(C6 === "TB-ZELENA-70", "PTB71ADAP000", null))))))))));
  return tip;
  */
  return _temp_prevodilac(C6, ident_materijala_za_profil_osnovni_RECNIK);
};


const _calculate_ident_materijala_za_profil_pregradni = (C6) => {
  /*
  const tip = XIF(C6 === "STD-50", "PTP11AA00000", XIF(C6 === "STD-70", "PTP10AA00000", XIF(C6 === "TB-50", "PTB52AA00000", XIF(C6 === "TB-70", "PTB72AA00000", XIF(C6 === "STD-BELA-50", "PTP11ADAN000", XIF(C6 === "STD-BELA-70", "PTP10ADAN000", XIF(C6 === "TB-BELA-50", "PTB52ADBC000", XIF(C6 === "TB-BELA-70", "PTB72ADAN000", XIF(C6 === "TB-PLAVA-70", "PTB72ADAM000", XIF(C6 === "TB-ZELENA-70", "PTB72ADAP000", null))))))))));
  return tip;
  */
  return _temp_prevodilac(C6, ident_materijala_za_profil_pregradni_RECNIK);
};

const _calculate_naziv_materijala_za_profil_osnovni = (C6) => {
  /*
  const naziv = XIF(C6 === "STD-50", "PROFIL AL OSNOVNI P8 50 TP08 SIROV", XIF(C6 === "STD-70", "PROFIL AL OSNOVNI P9 70 TP09 SIROV", XIF(C6 === "TB-50", "PROFIL AL OSNOVNI TERMALNI PREKID PTT 150-45 TB51 SIROV", XIF(C6 === "TB-70", "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 SIROV", XIF(C6 === "STD-BELA-50", "PROFIL AL OSNOVNI P8 50 TP08 PLASTIFICIRAN RAL9016MAT", XIF(C6 === "STD-BELA-70", "PROFIL AL OSNOVNI P9 70 TP09 PLASTIFICIRAN RAL9016MAT", XIF(C6 === "TB-BELA-50", "PROFIL AL OSNOVNI TERMALNI PREKID PTT 150-45 TB51 PLASTIFICIRAN RAL9003", XIF(C6 === "TB-BELA-70", "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 PLASTIFICIRAN RAL9016MAT", XIF(C6 === "TB-PLAVA-70", "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 PLASTIFICIRAN RAL5007MAT", XIF(C6 === "TB-ZELENA-70", "PROFIL AL OSNOVNI TERMALNI PREKID PTS 170-50 TB71 PLASTIFICIRAN RAL6024MAT", null))))))))));
  return naziv;
  */
  return _temp_prevodilac(C6, naziv_materijala_za_profil_osnovni_RECNIK);
};

const _calculate_naziv_materijala_za_profil_pregradni = (C6) => {
  /*
  const naziv = XIF(C6 === "STD-50", "PROFIL AL PREGRADNI P11 50 TP11 SIROV", XIF(C6 === "STD-70", "PROFIL AL PREGRADNI P10 70 TP10 SIROV", XIF(C6 === "TB-50", "PROFIL AL PREGRADNI TERMALNI PREKID PTT 250-45 TB52 SIROV", XIF(C6 === "TB-70", "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 SIROV", XIF(C6 === "STD-BELA-50", "PROFIL AL PREGRADNI P11 50 TP11 PLASTIFICIRAN RAL9016MAT", XIF(C6 === "STD-BELA-70", "PROFIL AL PREGRADNI P10 70 TP10 PLASTIFICIRAN RAL9016MAT", XIF(C6 === "TB-BELA-50", "PROFIL AL PREGRADNI TERMALNI PREKID PTT 250-45 TB52 PLASTIFICIRAN RAL9003", XIF(C6 === "TB-BELA-70", "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 PLASTIFICIRAN RAL9016", XIF(C6 === "TB-PLAVA-70", "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 PLASTIFICIRAN RAL5007MAT", XIF(C6 === "TB-ZELENA-70", "PROFIL AL PREGRADNI TERMALNI PREKID PTS 270-50 TB72 PLASTIFICIRAN RAL6024MAT", null))))))))));
  return naziv;
  */
  return _temp_prevodilac(C6, naziv_materijala_za_profil_pregradni_RECNIK);
};


export const derivatAutoCreateVirtel_modulprofil_priprema_ulaza = (virtel_m) => {
  console.log('derivatAutoCreateVirtel_modulprofil_priprema_ulaza(virtel_m)');
  console.log(virtel_m);
  // PRPREMA ULAZNIH VELICINA ZA DERIVAT FORMULU
  // REZULAT OVE FUNKCIJE JE JEDAN JEDNOSTAVAN OBJEKAT SA ULAZNIM VELICINAMA ZA DERIVAT FORMULU

  // console.log('***modul', virtel_m);

  // osnovni duzinski, visinski, sirinski... svaki od prethodnih po 4 komada.
  // njihove duzine zavise od TIPA PROFILA koji se bira kad i klima komora i vec su izracunate u virtel_k i prenesene u virtel_m

  let brojkomadaprofilpregradnivisinski = 0;
  if (virtel_m.brojkomadaprofilpregradnivisinski > 0) {
    brojkomadaprofilpregradnivisinski = virtel_m.brojkomadaprofilpregradnivisinski;
  };
  let brojkomadaprofilpregradnisirinski = 0;
  if (virtel_m.brojkomadaprofilpregradnisirinski > 0) {
    brojkomadaprofilpregradnisirinski = virtel_m.brojkomadaprofilpregradnisirinski;
  };

  // returnujemo jednostavan objekat sa svim ulaznim velicinama za derivat formulu
  const pods_input = {
    vrstaprofila: virtel_m.vrstaprofila, // C6
    duzinamodula: virtel_m.duzinamodula, // C13
    msirinaspoljasnja: virtel_m.msirinaspoljasnja, // NOVO 2021 AVGUST koristimo SPOLJASNJU
    mvisinaspoljasnja: virtel_m.mvisinaspoljasnja, // NOVO 2021 AVGUST koristimo SPOLJASNJU,
    brojkomadaprofilpregradnisirinski,
    brojkomadaprofilpregradnivisinski,
    // profili za obradu
    _extras_profili_za_obradu: {
      modulprofilosnovni_kolikozaobradu_sirinski: virtel_m.modulprofilosnovni_kolikozaobradu_sirinski,
      modulprofilosnovni_kolikozaobradu_duzinski: virtel_m.modulprofilosnovni_kolikozaobradu_duzinski,
      modulprofilosnovni_kolikozaobradu_visinski: virtel_m.modulprofilosnovni_kolikozaobradu_visinski,
      modulprofilpregradni_kolikozaobradu_sirinski: virtel_m.modulprofilpregradni_kolikozaobradu_sirinski, //
      modulprofilpregradni_kolikozaobradu_visinski: virtel_m.modulprofilpregradni_kolikozaobradu_visinski, //
    },
  };
  console.log('return pods_input', pods_input);
  return pods_input;
};


export const derivatAutoCreateVirtel_modulprofil = (pods_input) => {
  console.log('derivatAutoCreateVirtel_modulprofil(pods_input)');
  console.log(pods_input);

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xm = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela
  const C6 = pods_input.vrstaprofila; // mora da primi vrsta profila (od komore)

  const C13 = pods_input.duzinamodula;

  const E13 = pods_input.msirinaspoljasnja; // NOVO 2021 AVGUST koristimo SPOLJASNJU
  const D13 = pods_input.mvisinaspoljasnja; // NOVO 2021 AVGUST koristimo SPOLJASNJU


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  // derivati za osnovne profile

  const _profilosnovni_uzor = {
    ...pods_input,
    virtelschemakey: 'terkk$modul$profilosnovni',
    _draftelschemakey: 'terkk$modul$profilosnovni',
    virtelclass: "terkk$profilosnovni",
    terkknivo: 'CHILDOFMODUL',
    multitranslator_lang: "terkk$grupa_profil/grupa_profil",
    ..._getParamsFromLib("terkk$profilosnovni"),
  };
  const _extras_profili_za_obradu = pods_input._extras_profili_za_obradu;
  delete _profilosnovni_uzor._extras_profili_za_obradu;
  _profilosnovni_uzor.tip = _calculate_ident_materijala_za_profil_osnovni(C6);
  _profilosnovni_uzor._materijal_naziv = _calculate_naziv_materijala_za_profil_osnovni(C6);


  // derivat 1
  // derivat local 1
  _derivat_key = "osnovnisirinski";
  x = {
    _derivat_key,
    ..._profilosnovni_uzor,
    kolicina: 4,
  };
  if (_extras_profili_za_obradu.modulprofilosnovni_kolikozaobradu_sirinski > 0) {
    x.modulprofil_kolikozaobradu = _extras_profili_za_obradu.modulprofilosnovni_kolikozaobradu_sirinski;
  }
  x.duzina = XIF(C6 === "STD-50", E13 - 140, XIF(C6 === "STD-70", E13 - 180, XIF(C6 === "TB-50", E13 - 140, XIF(C6 === "TB-70", E13 - 180, XIF(C6 === "STD-BELA-50", E13 - 140, XIF(C6 === "STD-BELA-70", E13 - 180, XIF(C6 === "TB-BELA-50", E13 - 140, XIF(C6 === "TB-BELA-70", E13 - 180, XIF(C6 === "TB-PLAVA-70", E13 - 180, XIF(C6 === "TB-ZELENA-70", E13 - 180, null))))))))));
  x.calculated_ident = _calculate_ident(C6);
  x.tip = _profilosnovni_uzor.tip;
  _materijal_naziv = _profilosnovni_uzor._materijal_naziv;
  x._materijal_naziv = _profilosnovni_uzor._materijal_naziv;
  // x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.naziv = "PROFIL OSNOVNI ŠIRINSKI" + SPACE + x.duzina + 'mm'; // DL 2023-09-12
  x = {
    ...x,
    ..._getParamsFromLib("terkk$profilosnovni")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 3.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_modulprofil_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    virtelschemakey: 'terkk$modul$profil_materijal1'
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 2
  // derivat local 2
  _derivat_key = "osnovniduzinski";
  x = {
    _derivat_key,
    ..._profilosnovni_uzor,
    kolicina: 4,
  };
  console.log('**** ++++');
  console.log(x);
  if (_extras_profili_za_obradu.modulprofilosnovni_kolikozaobradu_duzinski > 0) {
    x.modulprofil_kolikozaobradu = _extras_profili_za_obradu.modulprofilosnovni_kolikozaobradu_duzinski;
  }
  // DUZINA JE U MILIMETRIMA
  x.duzina = XIF(C6 === "STD-50", C13 - 140, XIF(C6 === "STD-70", C13 - 180, XIF(C6 === "TB-50", C13 - 140, XIF(C6 === "TB-70", C13 - 180, XIF(C6 === "STD-BELA-50", C13 - 140, XIF(C6 === "STD-BELA-70", C13 - 180, XIF(C6 === "TB-BELA-50", C13 - 140, XIF(C6 === "TB-BELA-70", C13 - 180, XIF(C6 === "TB-PLAVA-70", C13 - 180, XIF(C6 === "TB-ZELENA-70", C13 - 180, null))))))))));
  x.calculated_ident = _calculate_ident(C6);
  x.tip = _profilosnovni_uzor.tip;
  _materijal_naziv = _profilosnovni_uzor._materijal_naziv;
  x._materijal_naziv = _profilosnovni_uzor._materijal_naziv;
  // x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.naziv = "PROFIL OSNOVNI DUŽINSKI" + SPACE + x.duzina + 'mm'; // DL 2023-09-12
  x = {
    ...x,
    multitranslator_lang: "terkk$grupa_profil/grupa_profil",
    ..._getParamsFromLib("terkk$profilosnovni")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 2.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_modulprofil_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    virtelschemakey: 'terkk$modul$profil_materijal1'
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);


  // derivat 3
  // derivat local 3
  _derivat_key = "osnovnivisinski";
  x = {
    _derivat_key,
    ..._profilosnovni_uzor,
    kolicina: 4,
  };
  if (_extras_profili_za_obradu.modulprofilosnovni_kolikozaobradu_visinski > 0) {
    x.modulprofil_kolikozaobradu = _extras_profili_za_obradu.modulprofilosnovni_kolikozaobradu_visinski;
  }
  x.duzina = XIF(C6 === "STD-50", D13 - 140, XIF(C6 === "STD-70", D13 - 180, XIF(C6 === "TB-50", D13 - 140, XIF(C6 === "TB-70", D13 - 180, XIF(C6 === "STD-BELA-50", D13 - 140, XIF(C6 === "STD-BELA-70", D13 - 180, XIF(C6 === "TB-BELA-50", D13 - 140, XIF(C6 === "TB-BELA-70", D13 - 180, XIF(C6 === "TB-PLAVA-70", D13 - 180, XIF(C6 === "TB-ZELENA-70", D13 - 180, null))))))))));
  x.calculated_ident = _calculate_ident(C6);
  x.tip = _profilosnovni_uzor.tip;
  _materijal_naziv = _profilosnovni_uzor._materijal_naziv;
  x._materijal_naziv = _profilosnovni_uzor._materijal_naziv;
  // x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.naziv = "PROFIL OSNOVNI VISINSKI" + SPACE + x.duzina + 'mm'; // DL 2023-09-12
  x = {
    ...x,
    multitranslator_lang: "terkk$grupa_profil/grupa_profil",
    ..._getParamsFromLib("terkk$profilosnovni")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


  // derivat local 3.1
  _derivat_key = _derivat_key + '_m';
  _mat = _derivat_modulprofil_materijal1_by_pp(x);
  xm = {
    ..._mat,
    _derivat_key,
    virtelschemakey: 'terkk$modul$profil_materijal1'
  };
  z[_derivat_key] = xm;
  _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xm);



  // --- derivati za PREGRADNE profile ---

  const _profilpregradni_uzor = {
    ...pods_input,
    virtelschemakey: 'terkk$modul$profilpregradni',
    _draftelschemakey: 'terkk$modul$profilpregradni',
    terkknivo: 'CHILDOFMODUL',
    multitranslator_lang: "terkk$grupa_profil/grupa_profil",
  };
  // _profilpregradni_uzor.tip = '';


  // derivat 4
  // derivat local 4 pregradni SIRINSKI
  _derivat_key = "pregradnisirinski";
  x = {
    _derivat_key,
    ..._profilpregradni_uzor,
    virtelclass: "terkk$profilpregradni_op_obrada",
  };
  x.kolicina = pods_input.brojkomadaprofilpregradnisirinski;
  if (_extras_profili_za_obradu.modulprofilpregradni_kolikozaobradu_sirinski > 0) {
    x.modulprofil_kolikozaobradu = _extras_profili_za_obradu.modulprofilpregradni_kolikozaobradu_sirinski;
  }
  x.duzina = XIF(C6 === "STD-50", E13 - 100, XIF(C6 === "STD-70", E13 - 140, XIF(C6 === "TB-50", E13 - 100, XIF(C6 === "TB-70", E13 - 140, XIF(C6 === "STD-BELA-50", E13 - 100, XIF(C6 === "STD-BELA-70", E13 - 140, XIF(C6 === "TB-BELA-50", E13 - 100, XIF(C6 === "TB-BELA-70", E13 - 140, XIF(C6 === "TB-PLAVA-70", E13 - 140, XIF(C6 === "TB-ZELENA-70", E13 - 140, null))))))))));
  x.calculated_ident = _calculate_ident(C6);
  x.tip = _calculate_ident_materijala_za_profil_pregradni(C6);
  _materijal_naziv = _calculate_naziv_materijala_za_profil_pregradni(C6);
  x._materijal_naziv = _calculate_naziv_materijala_za_profil_pregradni(C6);
  // x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.naziv = "PROFIL PREGRADNI" + SPACE + x.duzina + 'mm'; // DL 2023-09-12
  x = {
    ...x,
    ..._getParamsFromLib("terkk$profilpregradni_op_obrada")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  // Ako je broj komada za pregradni profil 0 onda izbrisi ovaj derivat
  if (z["pregradnisirinski"].kolicina === 0) {
    delete z["pregradnisirinski"];
    // _level1_counter -= 1; // smanjujemo counter jer smo izbacili ovaj poluproizvod
  } else {
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    // derivat local 4.1
    _derivat_key = "pregradnisirinski" + '_op_secenje';
    xx = {
      ...x, // najpre kopiramo profil_op_secenje
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      _derivat_key,
      virtelclass: "terkk$profilpregradni_op_secenje",
    };
    xx.calculated_ident = x.calculated_ident + '_S';
    xx = {
      ...xx,
      ..._getParamsFromLib("terkk$profilpregradni_op_secenje")
    }; // parametri na kraju imaju prioritet
    delete xx.modulprofil_kolikozaobradu;
    z[_derivat_key] = xx;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xx);
    // derivat local 4.1.1
    _derivat_key = "pregradnisirinski" + '_m';
    _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    xxm = {
      ..._mat,
      _derivat_key,
      virtelschemakey: 'terkk$modul$profil_materijal1'
    };
    z[_derivat_key] = xxm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xxm);
  };


  // derivat 5
  // derivat local 5 pregradni VISINSKI
  _derivat_key = "pregradnivisinski";
  x = {
    _derivat_key,
    ..._profilpregradni_uzor,
    virtelclass: "terkk$profilpregradni_op_obrada",
  };
  x.kolicina = pods_input.brojkomadaprofilpregradnivisinski;
  if (_extras_profili_za_obradu.modulprofilpregradni_kolikozaobradu_visinski > 0) {
    x.modulprofil_kolikozaobradu = _extras_profili_za_obradu.modulprofilpregradni_kolikozaobradu_visinski;
  }
  x.duzina = XIF(C6 === "STD-50", D13 - 100, XIF(C6 === "STD-70", D13 - 140, XIF(C6 === "TB-50", D13 - 100, XIF(C6 === "TB-70", D13 - 140, XIF(C6 === "STD-BELA-50", D13 - 100, XIF(C6 === "STD-BELA-70", D13 - 140, XIF(C6 === "TB-BELA-50", D13 - 100, XIF(C6 === "TB-BELA-70", D13 - 140, XIF(C6 === "TB-PLAVA-70", D13 - 140, XIF(C6 === "TB-ZELENA-70", D13 - 140, null))))))))));
  x.calculated_ident = _calculate_ident(C6);
  x.tip = _calculate_ident_materijala_za_profil_pregradni(C6);
  _materijal_naziv = _calculate_naziv_materijala_za_profil_pregradni(C6);
  x._materijal_naziv = _calculate_naziv_materijala_za_profil_pregradni(C6);
  // x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
  x.naziv = "PROFIL PREGRADNI" + SPACE + x.duzina + 'mm'; // DL 2023-09-12
  x = {
    ...x,
    ..._getParamsFromLib("terkk$profilpregradni_op_obrada")
  }; // parametri na kraju imaju prioritet
  z[_derivat_key] = x;
  // Ako je broj komada za pregradni profil 0 onda izbrisi ovaj derivat
  if (z["pregradnivisinski"].kolicina === 0) {
    delete z["pregradnivisinski"];
    // _level1_counter -= 1; // smanjujemo counter jer smo izbacili ovaj poluproizvod
  } else {
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);
    // derivat local 5.1
    _derivat_key = "pregradnivisinski" + '_op_secenje';
    xx = {
      ...x, // najpre kopiramo profil_op_secenje
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      _derivat_key,
      virtelclass: "terkk$profilpregradni_op_secenje",
    };
    xx.calculated_ident = x.calculated_ident + '_S';
    xx = {
      ...xx,
      ..._getParamsFromLib("terkk$profilpregradni_op_secenje")
    }; // parametri na kraju imaju prioritet
    delete xx.modulprofil_kolikozaobradu;
    z[_derivat_key] = xx;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xx);
    // derivat local 5.1.1
    _derivat_key = "pregradnivisinski" + '_m';
    _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    xxm = {
      ..._mat,
      _derivat_key,
      virtelschemakey: 'terkk$modul$profil_materijal1'
    };
    z[_derivat_key] = xxm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xxm);
  };


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


export const derivatAutoCreateVirtel_modulprofilpregradniuncarr = (pods_input, _arr_profilpregradniunc) => {
  console.log('derivatAutoCreateVirtel_modulprofilpregradniuncarr(pods_input, _arr_profilpregradniunc)');
  console.log(_arr_profilpregradniunc);
  // derivat 6 UNIVERZALNI ZA VISE UNC PROFILA

  let z = {}; // rezultat
  let x = {}; // JOCKER promenjiva
  let xx = {}; // JOCKER promenjiva
  let xxm = {}; // JOCKER promenjiva
  let _derivat_key;
  let _mat;
  let _materijal_naziv;

  // promenljive iz excela
  const C6 = pods_input.vrstaprofila; // mora da primi vrsta profila (od komore)
  console.log('pods_input', pods_input);


  let virbom_ref = _virbom_manipulator.init(virbomCounter.generateFreshSubkey);


  const _profilpregradni_uzor = {
    ...pods_input,
    virtelschemakey: 'terkk$modul$profilpregradni',
    _draftelschemakey: 'terkk$modul$profilpregradni',
    terkknivo: 'CHILDOFMODUL',
    multitranslator_lang: "terkk$grupa_profil/grupa_profil",
    ..._getParamsFromLib("terkk$profilpregradni_op_obrada"),
  };
  // _profilpregradni_uzor.tip = '';


  // PETLJA---------
  let _counterProfiliUnc = 0;
  console.log(typeof _arr_profilpregradniunc);
  console.log(Array.isArray(_arr_profilpregradniunc));
  console.log(_arr_profilpregradniunc);
  _arr_profilpregradniunc.forEach((profil) => {
    // EACH
    _counterProfiliUnc++;
    let profilkey = 'customprofil_' + _counterProfiliUnc;


    // derivat EACH local 1
    _derivat_key = profilkey;
    x = {
      ..._profilpregradni_uzor,
      virtelclass: "terkk$profilpregradni_op_obrada",
      bomlevel_imported: profil.bomlevel_imported,
      duzina: profil.duzinaprofilpregradniunc,
      kolicina: profil.brojkomadaprofilpregradniunc,
    };
    if (profil.modulprofilpregradni_kolikozaobradu_unc > 0) {
      x.modulprofil_kolikozaobradu = profil.modulprofilpregradni_kolikozaobradu_unc;
    }
    x.calculated_ident = _calculate_ident(C6);
    x.tip = _calculate_ident_materijala_za_profil_pregradni(C6);
    _materijal_naziv = _calculate_naziv_materijala_za_profil_pregradni(C6);
    x._materijal_naziv = _calculate_naziv_materijala_za_profil_pregradni(C6);
    // x.naziv = _materijal_naziv + SPACE + x.duzina + 'mm';
    x.naziv = "PROFIL PREGRADNI" + SPACE + x.duzina + 'mm'; // DL 2023-09-12
    x = {
      ...x,
      ..._getParamsFromLib("terkk$profilpregradni_op_obrada")
    }; // parametri na kraju imaju prioritet
    z[_derivat_key] = x;
    _virbom_manipulator.add_on_top_graphlevel(virbom_ref, x);


    // derivat EACH local 1.1
    _derivat_key = _derivat_key + '_op_secenje';
    xx = {
      ...x, // najpre kopiramo profil_op_secenje
      kolicina: SINGLE_PIECE_PER_NEXT_OPERATION_UNIT, // PO JEDNOM KOMADU SLEDECE OPERACIJE
      _derivat_key,
      virtelclass: "terkk$profilpregradni_op_secenje",
    };
    delete xx.bomlevel_imported;
    xx.calculated_ident = x.calculated_ident + '_S';
    xx = {
      ...xx,
      ..._getParamsFromLib("terkk$profilpregradni_op_secenje")
    }; // parametri na kraju imaju prioritet
    delete xx.modulprofil_kolikozaobradu;
    z[_derivat_key] = xx;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xx);


    // derivat EACH local 1.1.1
    _derivat_key = _derivat_key + '_m';
    _mat = _derivat_modulprofil_materijal1_by_pp(xx);
    xxm = {
      ..._mat,
      _derivat_key,
      virtelschemakey: 'terkk$modul$profil_materijal1'
    };
    z[profilkey + '_m'] = xxm;
    _virbom_manipulator.add_as_last_virtel_children(virbom_ref, xxm);


  });  // end of PETLJA----------
  //


  console.log(z);


  const virbom_seq = _virbom_manipulator.deinit(virbom_ref);
  console.log('der_virbom_seq');
  console.log(virbom_seq);
  return virbom_seq;
};


export const _derivat_modulprofil_materijal1_by_pp = (p) => {
  // ova funkcija pravi dodatni materijal za svaki poluproizvod (p) koji je nastao kao derivat u nekim od formual iznad
  // TODO: proveriti da li i p prima prirubnicu kao input ili daje kao rezultat...

  const _materijal_naziv = p._materijal_naziv;

  let x = {
    naziv: _materijal_naziv
  };
  x.calculated_ident = p.tip;
  x.terkategorija = 'M';
  const _kolicina = p.duzina * SINGLE_PIECE_PER_NEXT_OPERATION_UNIT; // PO JEDNOM KOMADU SLEDECE OPERACIJE
  x.kolicina = terUtilsUnitsMilimetriToMetri(_kolicina, 3); // KONVERTUJEMO U METRE
  x.jm = tclocal.JM_M;
  return x;
};




// TODO Ispraviti ovo Privremeno resenje
export const derivatModulProfil_pregradni_duzine = (msirinaspoljasnja, mvisinaspoljasnja, vrstaprofila) => {
  const D13 = msirinaspoljasnja;
  const E13 = mvisinaspoljasnja;
  const C6 = vrstaprofila;

  let sirinskiPregradni = {};
  sirinskiPregradni.duzina = XIF(C6 === "STD-50", D13 - 100, XIF(C6 === "STD-70", D13 - 140, XIF(C6 === "TB-50", D13 - 100, XIF(C6 === "TB-70", D13 - 140, XIF(C6 === "STD-BELA-50", D13 - 100, XIF(C6 === "STD-BELA-70", D13 - 140, XIF(C6 === "TB-BELA-50", D13 - 100, XIF(C6 === "TB-BELA-70", D13 - 140, XIF(C6 === "TB-PLAVA-70", D13 - 140, XIF(C6 === "TB-ZELENA-70", D13 - 140, null))))))))));

  // TODO: PROVERITI moguce je da treba drugacija formula za visinske pregradne profile
  let visinskiPregradni = {};
  visinskiPregradni.duzina = XIF(C6 === "STD-50", E13 - 100, XIF(C6 === "STD-70", E13 - 140, XIF(C6 === "TB-50", E13 - 100, XIF(C6 === "TB-70", E13 - 140, XIF(C6 === "STD-BELA-50", E13 - 100, XIF(C6 === "STD-BELA-70", E13 - 140, XIF(C6 === "TB-BELA-50", E13 - 100, XIF(C6 === "TB-BELA-70", E13 - 140, XIF(C6 === "TB-PLAVA-70", E13 - 140, XIF(C6 === "TB-ZELENA-70", E13 - 140, null))))))))));

  return { sirinskiPregradni, visinskiPregradni };
};

